import { render, staticRenderFns } from "./TaskArrangePersonal.vue?vue&type=template&id=4bb988d0&scoped=true"
import script from "./TaskArrangePersonal.vue?vue&type=script&lang=js"
export * from "./TaskArrangePersonal.vue?vue&type=script&lang=js"
import style0 from "./TaskArrangePersonal.vue?vue&type=style&index=0&id=4bb988d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb988d0",
  null
  
)

export default component.exports